<script setup>
import { computed } from 'vue';
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import Sidenav from "./layout/Sidenav";
import Navbar from "@/layout/Navbars/Navbar.vue";
import AppFooter from "@/layout/Footer.vue";
import ConfirmModalHost from "@/components/modal/ConfirmModalHost.vue";

const store = useStore();
const route = useRoute();
const layout = computed(() => store.state.layout);
const showSidenav = computed(() => store.state.showSidenav);
const showNavbar = computed(() => store.state.showNavbar);
const showFooter = computed(() => store.state.showFooter);
const shouldApplyMainBodyRules = computed(() => route.name !== "Dashboard");
</script>
<template>
  <div v-show="layout === 'landing'" class="landing-bg h-100 bg-gradient-primary position-fixed w-100"></div>
  <sidenav v-if="showSidenav" />
  <main
    class="main-content position-relative app-main-layout"
    :class="{ 'app-main-layout--with-footer': showFooter }"
  >
    <navbar v-if="showNavbar" />
    <section
      class="app-main-body"
      :class="{ 'app-main-body--managed': shouldApplyMainBodyRules }"
    >
      <router-view />
    </section>
    <app-footer v-if="showFooter" />
  </main>
  <confirm-modal-host />
</template>

<style lang="scss">
.app-main-layout {
  height: 100dvh;
  min-height: 100dvh;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
  overflow: hidden;
}

.app-main-layout--with-footer {
  grid-template-rows: auto minmax(0, 1fr) auto;
  overflow: hidden;
}

.app-main-body--managed {
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
}

.app-main-layout > .footer {
  overflow: hidden;
}

.app-main-layout > .footer.py-4 {
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}

.app-main-body--managed .container-fluid {
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.app-main-body--managed .container-fluid:has(.argon-table-container) {
  height: 100%;
}

.app-main-body--managed .container-fluid:has(.argon-table-container) > .row {
  flex: 1 1 auto;
  min-height: 0;
}

.app-main-body--managed .container-fluid:has(.argon-table-container) > .row > [class*="col-"] {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.app-main-body--managed .container-fluid > .row > [class*="col-"] > *:has(.argon-table-container) {
  flex: 1 1 auto;
  min-height: 0;
}

.app-main-body--managed .card:has(.argon-table-container) {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.app-main-body--managed .card:has(.argon-table-container) > .card-body {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

</style>
